function registerAlertItems() {
  const alerts = document.querySelectorAll('.alert-items > .alert')
  const alertsTop = document.querySelectorAll('.alert-items-top > .alert')


  eventRegistration(alerts)
  eventRegistration(alertsTop)

}

function eventRegistration(alertList) {
  const currentDate = new Date()

  alertList.forEach(alert => {
    const alertDismissDays = parseInt(alert.dataset.alertDismissDurationDays)
    const alertId = alert.dataset.alertId
    const alertDismissButton = alert.querySelector('.alert-dismiss-button')

    alertDismissButton?.addEventListener('click', event => {
      if (alertDismissDays === 0) {
        // Use session storage for alerts set to dismiss after 0 days
        sessionStorage.setItem(`alert-dismiss-${alertId}`, 'session')
      } else {
        // Use local storage for alerts set to dismiss otherwise, containing date they will no longer be dismissed
        const dismissUntilDate = new Date(currentDate)
        dismissUntilDate.setDate(currentDate.getDate() + alertDismissDays)
        localStorage.setItem(`alert-dismiss-${alertId}`, dismissUntilDate)
      }
    })

    // If alert is not dismissed in either session nor local storage, then show it
    const sessionStorageDismissValue = sessionStorage.getItem(`alert-dismiss-${alertId}`)
    const localStorageDismissUntilDate = new Date(localStorage.getItem(`alert-dismiss-${alertId}`))
    if (!sessionStorageDismissValue && localStorageDismissUntilDate < currentDate) {
      alert.classList.add('show')
    }
  })
}

document.addEventListener('DOMContentLoaded', (event) => {
  registerAlertItems()
})
